/* Scroll reveal di tutto il sito.

   Lo script decide da solo quale effetto dare a ogni elemento, in base a cosa
   e, senza classi da aggiungere nelle sezioni:

     - testi, titoli, bottoni .............. fade-up        (rv-up)
     - box con foto di sfondo, card ........ fade-up        (rv-up)
     - immagini, filtri a pillola .......... fade-up        (rv-up)
     - caroselli (Splide) .................. fade-up        (rv-up)
     - linee di separazione ................ si disegnano   (rv-line)
     - barra di navigazione ................ scende con fade (rv-down)

   Ogni elemento si anima una volta sola, quando entra nello schermo, poi le
   classi vengono tolte e torna com'era. Gli stili che nascondono (in
   base-concrete.css) valgono solo se html ha la classe rv-js, messa dallo
   script in <head>: senza JavaScript la pagina resta tutta visibile. */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('rv-js')) return;

  var PASSO = 80; /* ritardo tra un elemento e il successivo (ms) */
  var RITARDO_MAX = 400; /* tetto del ritardo a cascata (ms) */
  var ATTESA_IMMAGINE = 1500; /* oltre questo tempo la tenda parte comunque */
  /* Elenchi "una riga alla volta": i figli di un contenitore con l'attributo
     data-rv-seq compaiono in ordine, dal primo all'ultimo, senza tetto. */
  var SEQ_INIZIO = 300; /* attesa prima della prima riga (ms) */
  var SEQ_PASSO = 200; /* ritardo tra una riga e la successiva (ms) */

  /* Dentro questi contenitori non si anima nulla. */
  var SALTA =
    '.splide, dialog, [hidden], [inert], template, .footer_slogan, .prodotto_card_overlay, [data-rv-off]';
  var TESTI =
    '[class*="title-"], [class*="text-"], [class*="label-"], .buganBotton, .buganBotton_white, h1, h2, h3, h4, h5, h6, p';
  var CAMPI = 'select, input, textarea, option';
  /* Blocchi che salgono con fade tutti interi anche se non hanno una foto di
     sfondo: i filtri a pillola delle collezioni (dentro hanno un select, che
     da solo non si anima) e le voci degli elenchi data-rv-seq, qualunque
     cosa siano (per esempio i tag delle location). */
  var BLOCCHI = '[data-pill], [data-rv-seq] > *';

  var inAttesa = [];
  var observer = null;

  function pronto() {
    root.classList.add('rv-ready');
  }

  function saltato(el) {
    return !!el.closest(SALTA);
  }

  function dentroUnGiaPreso(el, presi) {
    for (var p = el.parentElement; p; p = p.parentElement) {
      if (presi.has(p)) return true;
    }
    return false;
  }

  /* Senza dimensioni, oppure tenuto invisibile dal suo CSS (opacity 0): e il
     caso delle immagini che compaiono solo all'hover, che non vanno toccate. */
  function visibile(el) {
    var r = el.getBoundingClientRect();
    if (r.width <= 0 || r.height <= 0) return false;
    return getComputedStyle(el).opacity !== '0';
  }

  function raccogli(ambito, presi, lista) {
    var vw = window.innerWidth;
    var vh = window.innerHeight;

    function prendi(el, tipo) {
      presi.set(el, tipo);
      lista.push(el);
    }

    /* 1. Caroselli: salgono con fade tutti interi, il loro contenuto non si
          anima. */
    ambito.querySelectorAll('.splide').forEach(function (el) {
      /* Il carosello stesso e nell'elenco SALTA: si guardano solo gli antenati. */
      if (el.parentElement && el.parentElement.closest(SALTA)) return;
      if (!visibile(el)) return;
      /* Si anima la traccia e non il carosello: il carosello puo avere lo
         sfondo della sezione (come le sedi in home), e mentre e trasparente
         lascerebbe vedere le sezioni che ci stanno dietro. */
      prendi(el.querySelector('.splide__track') || el, 'up');
    });

    /* 2. Riquadri con foto di sfondo e card prodotto: sono box normali,
          salgono con fade come un blocco unico, sfondo e testi insieme
          (niente tenda, che e riservata alle immagini vere, i tag img). La
          foto di sfondo si riconosce dallo stile calcolato, quindi vale sia
          se e scritta nello style dell'elemento sia se sta nel CSS. I
          riquadri grandi quanto lo schermo, cioe le hero, non sono un
          blocco unico: si animano i testi che contengono. */
    ambito.querySelectorAll('div, a, span, li, section, article, figure').forEach(function (el) {
      if (saltato(el) || dentroUnGiaPreso(el, presi)) return;
      var eCard = el.classList.contains('prodotto_card');
      if (!eCard && getComputedStyle(el).backgroundImage.indexOf('url(') === -1) return;
      if (!visibile(el)) return;
      var r = el.getBoundingClientRect();
      var grande = r.width >= vw * 0.9 && r.height >= vh * 0.5;
      if (el.children.length > 0 && grande) return;
      prendi(el, 'up');
    });

    /* 3. Immagini. Le icone piccole restano ferme. */
    ambito.querySelectorAll('img').forEach(function (el) {
      if (saltato(el) || dentroUnGiaPreso(el, presi)) return;
      var r = el.getBoundingClientRect();
      /* Un'immagine lazy non ancora scaricata e senza width/height nell'HTML
         ha altezza zero: e comunque da animare, basta che abbia larghezza. */
      var daCaricare = !el.complete && r.width > 0;
      if (!daCaricare && !visibile(el)) return;
      if (getComputedStyle(el).opacity === '0') return;
      if (r.width < 64) return;
      var src = el.currentSrc || el.getAttribute('src') || '';
      /* Si chiede subito il file, senza aspettare il lazy load: altrimenti
         l'immagine inizierebbe a scaricarsi solo arrivandoci sopra e
         l'effetto partirebbe in ritardo. */
      el.loading = 'eager';
      /* Le immagini salgono con fade, come i box con foto di sfondo. La
         tenda (rv-curtain) resta disponibile nel CSS ma non viene usata. */
      prendi(el, 'up');
    });

    /* 3b. Blocchi dell'elenco BLOCCHI. */
    ambito.querySelectorAll(BLOCCHI).forEach(function (el) {
      if (saltato(el) || presi.has(el) || dentroUnGiaPreso(el, presi) || !visibile(el)) return;
      prendi(el, 'up');
    });

    /* 4. Testi: vince l'elemento piu esterno, quelli dentro non si animano
          a parte. */
    ambito.querySelectorAll(TESTI).forEach(function (el) {
      if (el.matches(CAMPI)) return;
      if (saltato(el) || presi.has(el) || dentroUnGiaPreso(el, presi) || !visibile(el)) return;
      prendi(el, 'up');
    });

    /* 5. Linee: elementi con un bordo solo sopra e/o sotto. */
    ambito.querySelectorAll('div, li, a').forEach(function (el) {
      if (presi.has(el) || saltato(el) || dentroUnGiaPreso(el, presi)) return;
      var s = getComputedStyle(el);
      var sopra = parseFloat(s.borderTopWidth) > 0 && s.borderTopStyle === 'solid';
      var sotto = parseFloat(s.borderBottomWidth) > 0 && s.borderBottomStyle === 'solid';
      if (!sopra && !sotto) return;
      if (parseFloat(s.borderLeftWidth) > 0 || parseFloat(s.borderRightWidth) > 0) return;
      if (parseFloat(s.borderTopLeftRadius) > 0) return;
      if (el.getBoundingClientRect().width < 160) return;
      el.style.setProperty('--rv-line-color', sopra ? s.borderTopColor : s.borderBottomColor);
      prendi(el, 'line');
    });
  }

  function pulisci(el) {
    el.classList.remove('rv', 'rv-up', 'rv-down', 'rv-right', 'rv-curtain', 'rv-line', 'rv-in');
    el.style.removeProperty('animation-delay');
    el.style.removeProperty('--rv-line-color');
    var i = inAttesa.indexOf(el);
    if (i !== -1) inAttesa.splice(i, 1);
  }

  /* La tenda di una foto parte solo a immagine caricata, altrimenti si
     aprirebbe sul vuoto. */
  function quandoCaricata(el, fatto) {
    var chiamato = false;
    function una() {
      if (chiamato) return;
      chiamato = true;
      fatto();
    }

    var img = el.tagName === 'IMG' ? el : el.querySelector('img');
    if (img) {
      if (img.complete) return una();
      img.addEventListener('load', una, { once: true });
      img.addEventListener('error', una, { once: true });
      setTimeout(una, ATTESA_IMMAGINE);
      return;
    }

    var m = /url\(\s*['"]?([^'")]+)['"]?\s*\)/.exec(el.getAttribute('style') || '');
    if (!m) return una();
    var prova = new Image();
    prova.onload = una;
    prova.onerror = una;
    prova.src = m[1];
    if (prova.complete) return una();
    setTimeout(una, ATTESA_IMMAGINE);
  }

  function anima(el, ritardo) {
    if (observer) observer.unobserve(el);
    if (!el.classList.contains('rv') || el.classList.contains('rv-in')) return;

    function via() {
      el.style.animationDelay = ritardo + 'ms';
      el.addEventListener('animationend', function fine(e) {
        if (e.target !== el || e.animationName.indexOf('rv-') !== 0) return;
        el.removeEventListener('animationend', fine);
        pulisci(el);
      });
      el.classList.add('rv-in');
      /* Rete di sicurezza: se animationend non arriva, l'elemento torna
         comunque visibile. */
      setTimeout(function () {
        if (el.classList.contains('rv')) pulisci(el);
      }, ritardo + 2500);
    }

    if (el.classList.contains('rv-curtain')) quandoCaricata(el, via);
    else via();
  }

  function animaGruppo(elementi) {
    elementi
      .map(function (el) {
        var r = el.getBoundingClientRect();
        return { el: el, top: r.top, left: r.left };
      })
      .sort(function (a, b) {
        return Math.abs(a.top - b.top) > 8 ? a.top - b.top : a.left - b.left;
      })
      .reduce(function (i, voce) {
        var genitore = voce.el.parentElement;
        if (genitore && genitore.hasAttribute('data-rv-seq')) {
          var riga = Array.prototype.indexOf.call(genitore.children, voce.el);
          anima(voce.el, SEQ_INIZIO + riga * SEQ_PASSO);
          return i;
        }
        anima(voce.el, Math.min(i * PASSO, RITARDO_MAX));
        return i + 1;
      }, 0);
  }

  function avvia() {
    if (!('IntersectionObserver' in window)) return pronto();

    var presi = new Map();
    var lista = [];
    var ambiti = [document.getElementById('MainContent'), document.querySelector('body > footer')];
    ambiti.forEach(function (ambito) {
      if (ambito) raccogli(ambito, presi, lista);
    });

    /* Barra di navigazione: scende dall'alto come un blocco unico (logo e
       icone insieme). Il pannello del menu non viene toccato. */
    var barra = document.querySelector('.bugan_header');
    if (barra && visibile(barra)) {
      presi.set(barra, 'down');
      lista.push(barra);
    }

    lista.forEach(function (el) {
      el.classList.add('rv', 'rv-' + presi.get(el));
      inAttesa.push(el);
    });

    observer = new IntersectionObserver(
      function (voci) {
        var entrati = [];
        voci.forEach(function (voce) {
          if (voce.isIntersecting) {
            entrati.push(voce.target);
          } else if (voce.boundingClientRect.bottom < 0) {
            /* Gia sopra lo schermo (pagina aperta a meta): si mostra subito,
               senza animazione. */
            observer.unobserve(voce.target);
            pulisci(voce.target);
          }
        });
        if (entrati.length) animaGruppo(entrati);
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0 }
    );

    lista.forEach(function (el) {
      observer.observe(el);
    });

    /* Prima schermata: tutto cio che e gia nello schermo all'apertura parte
       subito, anche se sta negli ultimi pixel in basso, dove il margine
       negativo dell'observer non lo farebbe scattare fino al primo scroll. */
    animaGruppo(
      lista.filter(function (el) {
        var r = el.getBoundingClientRect();
        return r.top < window.innerHeight && r.bottom > 0;
      })
    );

    /* Fondo pagina: con il margine negativo gli ultimi elementi potrebbero
       non raggiungere mai la soglia. Arrivati in fondo si mostra tutto. */
    function fondoPagina() {
      if (!inAttesa.length) return window.removeEventListener('scroll', fondoPagina);
      var fondo = window.innerHeight + window.scrollY >= root.scrollHeight - 4;
      if (!fondo) return;
      animaGruppo(
        inAttesa.filter(function (el) {
          var r = el.getBoundingClientRect();
          return !el.classList.contains('rv-in') && r.top < window.innerHeight && r.bottom > 0;
        })
      );
    }
    window.addEventListener('scroll', fondoPagina, { passive: true });

    /* Gli elementi sono nascosti dalle classi rv-*: ora si puo togliere il
       velo messo sul main in attesa dello script. */
    pronto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
